/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox, openlightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import { Factor } from ".";

const CardReplace = (props) => {
	const [zPos, setZPos] = useState(45)
  const [reason, setReason] = useState(-1);
  const [chargeAmount, setChargeAmount] = useState(0.0);
  const [disabled, setDisabled] = useState(true);
  const history = useHistory();

  const onSelectReason = (e) => {
    let value = e.target.value;
    let cats = props.content.catalog;
    let amount = 0;
    for (let i = 0; i < cats.length; i++) {
      if (cats[i]["k"] == value) {
        if (props.partner == "albo-partner-cacaopay-paycard") {
          if (cats[i]["m"][0].hasOwnProperty("charge_amount_paycard")) {
            amount = cats[i]["m"][0]["charge_amount_paycard"];
          } else {
            amount = cats[i]["m"][0]["charge_amount"];
          }
          break;
        }

        if (props.partner == "albo-partner-tutuka") {
          if (cats[i]["m"][0].hasOwnProperty("charge_amount_tutuka")) {
            amount = cats[i]["m"][0]["charge_amount_tutuka"];
          } else {
            amount = cats[i]["m"][0]["charge_amount"];
          }
          break;
        }

        amount = cats[i]["m"][0]["charge_amount"];
        break;
      }
    }
    setChargeAmount(Number(amount));
    setReason(value);
    verifyButton(value);
  };

  const verifyButton = (value) => {
    if (value > -1) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const send = async () => {
    props.changeLoader(true);
		setZPos(-1)

    let data = {
      customerUuid: props.content.customerUuid,
      cardUuid: props.content.cardUuid,
      spaceUuid: props.content.spaceUuid,
      provider: props.content.partner,
      reason: reason,
    };

    let request = await API.service( "cardReplace", data, props.pos, props.changeAlert, props.changeLoader, history );
    if (request.status == 200 && request.data.data.response == "OK" && request.data.data.content ) {
      closelightbox();
      if (request.data.data.content.type == "2FA" || request.data.data.content.type == "1FA" ) {
        let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
        factors[props.content.customerUuid] = request.data.data.content.uuid_factor;
        localStorage.factors = JSON.stringify(factors);
      }
      const as = (
        <Factor
          intent="cardCancel"
          contentModal={request.data.data.content}
          pos={props.pos}
          changeAlert={props.changeAlert}
          changeLoader={props.changeLoader}
          history={history}
          key="factor"
        />
      );
      openlightbox(as);
    }

    if ( request.status == 200 && request.data.data.response == "OK" && !request.data.data.content ) {
      props.changeAlert(true, "success", "Tarjeta reemplazada con éxito");
      await props.changeReload();
      closelightbox();
    }
    props.changeLoader(false);
		setZPos(45)
  };

  return (
		<Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
			<ModalStyle property={String(disabled)}>
				<DialogTitle>
					Reemplazar Tarjeta {props.content.type === "physical" ? "Física" : "Virtual" }
					<IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
				</DialogTitle>
				
				<DialogContent>
					<Grid container spacing={2} sx={{ marginTop: "10px" }}>
						<Grid item xs={6}>
							<TextField label="Motivo" value={reason}	onChange={onSelectReason.bind(this)} select	size="small" fullWidth >
									<MenuItem value="-1" >Selecione</MenuItem>
								{props.content?.catalog?.map((item, index) => (
									<MenuItem key={`replace-option-${index}`} value={item.k}>{item.v}</MenuItem>
								))}
							</TextField>
						</Grid>
						{reason > 0 &&
							<Grid item xs={6} style={{alignSelf: "center"}}>
								* Con costo a cliente de ${chargeAmount} MXN       
							</Grid>						
						}
						{props.content.type === "physical" &&
							<>
								<Grid item xs={12} style={{fontWeight: "bolder"}}>
									<hr/>
									Dirección de envío  
								</Grid>	
								<Grid item xs={12} >
									{props.content.address ? props.content.address : "N/A"}
								</Grid>					
							</>
						}
					</Grid>
				</DialogContent>

				<DialogActions>					
					<Button disabled={disabled} variant="contained" onClick={send.bind(this)}>Aceptar</Button>
				</DialogActions>
			</ModalStyle>
		</Dialog>
  );
};

export default CardReplace;
